import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ServicesGrid } from "@/components/home/ServicesGrid";
import { InStorePrices } from "@/components/home/InStorePrices";
import { LocalGallery } from "@/components/home/LocalGallery";
import { HowItWorks } from "@/components/home/HowItWorks";
import { Reviews } from "@/components/home/Reviews";
import { LocationHours } from "@/components/home/LocationHours";
import { FAQ } from "@/components/home/FAQ";
import { ContactSection } from "@/components/home/ContactSection";
import { AdBanner } from "@/components/AdBanner";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <InStorePrices />
      <LocalGallery />
      <ServicesGrid />
      <AdBanner className="py-6 bg-white" />
      <HowItWorks />
      <Reviews />
      <LocationHours />
      <FAQ />
      <AdBanner className="py-6 bg-slate-50" />
      <ContactSection />
      <Footer />
    </div>
  );
}
